import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomizedSelectoption from "../General/CustomizedSelectoption";
import { Show_Message } from "../General/Messagedialogbox";
import {
  refresh_Settlementdt,
  clear_SettlementResult,
  setSettlementVenParem,
  setSettlementVendor,
  setSettlementVoucher,
  setnewsettlment,
  setselectedpayrec,
  setselectedvoucher,
  setsettlementdAmount,
  setsettlementfromdate,
  setsettlementtodate,
  setsettlementvouchtype,
} from "../features/Accounts";

import { Ask_Question } from "../General/Messagedialogbox";
import { API_FETCH, API_POST } from "../General/Utility";
import ReactTable from "../General/ReactTable";
function SettlementInput(props) {
  const dispatch = useDispatch();

  useEffect(() => {}, [props]);
  const _HTParem = useSelector((state) => state.Accounts.SettleMentHT);
  const _DTParem = useSelector((state) => state.Accounts.SettleMentDT);
  const _Selectparem = useSelector((state) => state.SelectOption.parems);
  const _AuthParems = useSelector((state) => state.Common.Admin);

  const reqId = useRef(0); // ignores out-of-order API responses
  const [iHTselected, setiHTselected] = useState(-1);
  const [iDTselected, setiDTselected] = useState(-1);
  const [arrVendore, setarrVendore] = useState([]);

    // Display only: DB keeps settled amount negative, grid shows it positive.
  // Redux data (sent to backend on Adjust / Save) is not changed.
  const showAbs = (arr) =>
    (arr || []).map((r) => ({
      ...r,
      adjustAmt: Math.abs(Number(r.adjustAmt || 0)),
    }));
  const arrHTShow = useMemo(
    () => showAbs(_DTParem.arrHTdata),
    [_DTParem.arrHTdata]
  );
  const arrDTShow = useMemo(
    () => showAbs(_DTParem.arrDTdata),
    [_DTParem.arrDTdata]
  );
  // Load the vendor list whenever the vendor type changes (and once the
  // session DB is available) so the dropdown never shows the wrong type's list.
  useEffect(() => {
    if (_HTParem.iVenTypeId && _AuthParems.DB) {
      View_AllVendores(_HTParem.iVenTypeId, "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_HTParem.iVenTypeId, _AuthParems.DB]);

  const Ven_typeonchange = (VenTypeId) => {
    if (Number(VenTypeId) === Number(_HTParem.iVenTypeId)) return;
    switch (VenTypeId) {
      case 4:
        dispatch(
          setSettlementVenParem({
            iScrId: 17,
            iVenScrId: 2,
            strVenScrCol: "CustName",
            iVenTypeId: VenTypeId,
          })
        );
        break;
      case 5:
        dispatch(
          setSettlementVenParem({
            iScrId: 73,
            iVenScrId: 50,
            strVenScrCol: "VenName",
            iVenTypeId: VenTypeId,
          })
        );
        break;
      default:
        dispatch(
          setSettlementVenParem({
            iScrId: 11,
            iVenScrId: 3,
            strVenScrCol: "SuppName",
            iVenTypeId: VenTypeId,
          })
        );
        break;
    }
    // setSettlementVenParem also clears the old vendor + both grids, so
    // nothing is loaded here until a vendor of the NEW type is chosen.
  };
  const View_AllVendores = async (VenType, strtext) => {
    if (!_AuthParems.DB) return;
    let strcolname = "";
    let ScrId = 0;
    switch (VenType) {
      case 4:
        ScrId = 2;
        strcolname = "CustName";
        break;
      case 5:
        ScrId = 50;
        strcolname = "VenName";
        break;
      default:
        ScrId = 3;
        strcolname = "SuppName";
        break;
    }
    const parems = {
      iScrId: ScrId,
      iPartyId: VenType,
      strColName: strcolname,
      strSearch: strtext,
      strDBName: _AuthParems.DB,
      iBranchId: Number(_AuthParems.Branch),
    };
    const res = await API_POST(`PartyTrans/Search_Party`, parems, dispatch);
    if (res) setarrVendore(res.EntParty);
  };
  const View_Party = async (iVenId) => {
    const res = await API_FETCH(
      `${props.PartyUrl}/View_Party/${_HTParem.iVenTypeId}/${iVenId}/${Number(
        _AuthParems.Branch
      )}/${_AuthParems.DB}`,
      dispatch
    );
    if (res) {
      dispatch(
        setSettlementVendor({
          iVenId: Number(iVenId),
          strVenName: res.EntParty[0],
        })
      );
      LoadPayVouchers(iVenId, _HTParem.iScrId);
    }
  };
  // Calls the un-settled / settled API. Optional overrides let callers pass
  // values they JUST dispatched (Redux state in this render is still old).
  const FetchPayVouchers = async (VenId, Vouchtype, opts = {}) => {
    const objPaySett = {
      iScrId: Vouchtype,
      iVenType: opts.iVenType || _HTParem.iVenTypeId,
      iVenId: Number(VenId),
      dpFrom: opts.dpFrom || _HTParem.strFromDate,
      dpTo: opts.dpTo || _HTParem.strToDate,
      // FIX (root cause of "No Payments are found" after picking KVR):
      // this used to send the text typed in the VENDOR dropdown ("KVR") as
      // the payment search filter, so the server looked for payments
      // matching "KVR" instead of payments OF vendor KVR. No filter here.
      strSearch: "",
      iBranchId: Number(_AuthParems.Branch),
      strDBName: _AuthParems.DB,
    };
    const PaySettURL = _HTParem.isUnSettle
      ? "View_UnAdjustedPayVouch/"
      : "View_AdjustedPayVouch/";
    return API_POST(`${props.PartyUrl}/${PaySettURL}`, objPaySett, dispatch);
  };
  const LoadPayVouchers = async (VenId, Vouchtype, opts = {}) => {
    if (!Number(VenId)) {
      reqId.current++;
      dispatch(clear_SettlementResult());
      return;
    }
    const dpFrom = opts.dpFrom || _HTParem.strFromDate;
    const dpTo = opts.dpTo || _HTParem.strToDate;
    if (!dpFrom || !dpTo) return;
    if (dpFrom > dpTo) {
      Show_Message(dispatch, "From Date cannot be greater than To Date", "info");
      return;
    }
    const myReq = ++reqId.current;
    const res = await FetchPayVouchers(VenId, Vouchtype, {
      ...opts,
      dpFrom,
      dpTo,
    });
    if (myReq !== reqId.current || !res) return; // stale or failed
    const arrHT = res.EntPayRecHT || [];
    const arrDT = res.EntPayRecDT || [];
    // always drop the previous vendor's selection / grids first
    dispatch(clear_SettlementResult());
    if (arrHT.length > 0) {
      dispatch(
        setSettlementVoucher({
          iHTCount: arrHT.length,
          iDTCount: arrDT.length,
          arrHTdata: arrHT,
          arrDTdata: arrDT,
        })
      );
    } else if (!opts.silent) {
      Show_Message(
        dispatch,
        _HTParem.isUnSettle ? "No Payments are found" : "No Settlement are found",
        "info"
      );
    }
  };
  const GetPayRecId = (objRow) =>
    props.PartyUrl === "ReceiptSettlement" ? objRow.recId : objRow.payId;
  // Settled tab: double-click a payment -> load the vouchers it settled
  const LoadVouchers = async (objPayRec) => {
    const payrecid = GetPayRecId(objPayRec);
    const res = await API_FETCH(
      `${props.PartyUrl}/View_SettledVouchers/${payrecid}/${_HTParem.iScrId}/${_AuthParems.DB}`,
      dispatch
    );
    if (res) {
      dispatch(
        setselectedpayrec({
          iPayRecId: payrecid,
          dBalAmount: Number(objPayRec.unAdjustAmt || 0).toFixed(2),
          arrDTdata: res.EntPayRecDT || [],
        })
      );
    }
  };
  // Un-settled tab: double-click a payment to settle it.
  const SelectPayment = async (objPayRec) => {
    const payrecid = GetPayRecId(objPayRec);
    let arrDT = _DTParem.arrDTdata;
    // FIX: switching to a DIFFERENT payment kept the amounts already typed /
    // adjusted for the previous payment in the voucher grid, so Save posted
    // those against the wrong payment. Reload a clean voucher list instead.
    const hasAdjustments = arrDT.some((r) => Number(r.amount) !== 0);
    if (hasAdjustments && Number(_HTParem.iPayRecId) !== Number(payrecid)) {
      const res = await FetchPayVouchers(_HTParem.iVenId, _HTParem.iScrId);
      if (!res) return;
      arrDT = res.EntPayRecDT || [];
    }
    dispatch(
      setselectedpayrec({
        iPayRecId: payrecid,
        dBalAmount: Number(objPayRec.unAdjustAmt || 0).toFixed(2),
        arrDTdata: arrDT,
      })
    );
  };
  const Adjust_Voucher = async () => {
    const dAmt = Number(_HTParem.dAmount);
    // index of the selected voucher inside the grid data. The backend needs
    // this; derive it from vouchId instead of relying on a click index.
    const iRow = _DTParem.arrDTdata.findIndex(
      (r) => Number(r.vouchId) === Number(_HTParem.iVouchId)
    );
    if (Number(_HTParem.iPayRecId) === 0) {
      Show_Message(dispatch, "Please Select  Payment", "info");
    } else if (Number(_HTParem.iVouchId) === 0 || iRow < 0) {
      Show_Message(dispatch, "Please Select Voucher", "info");
    } else if (!(dAmt > 0)) {
      Show_Message(dispatch, "Please Enter Valid Amount", "info");
    } else if (dAmt > Number(_HTParem.dUnSettleAmount) + 0.005) {
      Show_Message(
        dispatch,
        "Amount cannot be greater than the voucher's Un Settled Amount",
        "info"
      );
    } else if (dAmt > Number(_HTParem.dBalAmount) + 0.005) {
      Show_Message(
        dispatch,
        "Amount cannot be greater than the Available Amount",
        "info"
      );
    } else {
      const res = await API_POST(
        `${props.PartyUrl}/Add_Settlement/`,
        {
          dAmount: _HTParem.dAmount,
          dUnAdjAmt: _HTParem.dUnSettleAmount,
          strVouchType: _HTParem.strVouchType,
          // Receipt API expects objRecDetails, Payment API expects objPayDetails
          [props.PartyUrl === "ReceiptSettlement"
            ? "objRecDetails"
            : "objPayDetails"]: _DTParem.arrDTdata,
          iRowIndex: iRow,
          dBalAmt: _HTParem.dBalAmount,
          strDBName: _AuthParems.DB,
          iBranchId: Number(_AuthParems.Branch),
        },
        dispatch
      );
      if (res) {
        dispatch(refresh_Settlementdt());
        dispatch(
          setnewsettlment({
            arrDTdata: res.EntPayRecDT,
            dBalAmount: res.dBalAmt,
          })
        );
      }
    }
  };
  const Delete_Settlement = async (PaydtId) => {
    const res = await API_POST(
      `${props.PartyUrl}/Delete_Settlement/${PaydtId}/${_AuthParems.DB}`,
      {},
      dispatch
    );
    if (res) {
      // FIX: this used to wipe vendor type, voucher type and vendor (all
      // reset to 0) without reloading. Keep the filters and refresh the list.
      await LoadPayVouchers(_HTParem.iVenId, _HTParem.iScrId, {
        silent: true,
      });
      Show_Message(dispatch, res.strMessage, "success");
    }
  };
  const PayHTColumn = [
    {
      Header: "S.No",
      accessor: "sNo",
      style: { justifyContent: "center" },
      maxWidth: 70,
    },
    {
      Header: "Payment Mode",
      accessor: "paymentMode",
      style: { justifyContent: "center" },
    },
    {
      Header: "Payment Date",
      accessor: "payDate",
      style: { justifyContent: "center" },
    },
    {
      Header: "Payment No",
      accessor: "payNo",
      style: { justifyContent: "left" },
    },
    {
      Header: "Payment Amount",
      accessor: "payAmt",
      Cell: (props) => Number(props.value || 0).toFixed(2),
      style: { justifyContent: "right" },
    },
    {
      Header: "Settled Amount",
      accessor: "adjustAmt",
      Cell: (props) => Math.abs(Number(props.value || 0)).toFixed(2),
      style: { justifyContent: "right" },
    },
    {
      Header: "Balance Amount",
      accessor: "unAdjustAmt",
      Cell: (props) => Number(props.value || 0).toFixed(2),
      style: { justifyContent: "right" },
    },
  ];
  const PayDTColumn = [
    {
      Header: "S.No",
      accessor: "sNo",
      style: { justifyContent: "center" },
      maxWidth: 70,
    },
    {
      Header: "Vouch Type",
      accessor: "vouchType",
      style: { justifyContent: "left" },
    },
    {
      Header: "Bill Type",
      accessor: "billType",
      style: { justifyContent: "center" },
    },
    {
      Header: "Vouch Date",
      accessor: "vouchDate",
      style: { justifyContent: "center" },
    },
    {
      Header: "Vouch No",
      accessor: "vouchNo",
      minWidth: 200,
      style: { justifyContent: "left" },
    },
    {
      Header: "Vouch Amount",
      accessor: "vouchAmt",
      style: { justifyContent: "right" },
      Cell: (props) => Number(props.value || 0).toFixed(2),
    },
    {
      Header: "Settled Amount",
      accessor: "adjustAmt",
      style: { justifyContent: "right" },
      Cell: (props) => Math.abs(Number(props.value || 0)).toFixed(2),
    },
    {
      Header: "Balance Amount",
      accessor: "unAdjustAmt",
      style: { justifyContent: "right" },
      Cell: (props) => Number(props.value || 0).toFixed(2),
    },
    {
      Header: "Amount",
      accessor: "amount",
      style: { justifyContent: "right" },
      Cell: (props) => Number(props.value || 0).toFixed(2),
      show: _HTParem.isUnSettle,
    },
    {
      Header: "Options",
      id: "payDTId",
      maxWidth: 70,
      style: { justifyContent: "center" },
      show: !_HTParem.isUnSettle,
      accessor: (rowInfo) => (
        <div>
          <i
            onClick={(e) => {
              Ask_Question(
                dispatch,
                Delete_Settlement,
                "Do You Want to  Delete Settlement?",
                rowInfo.payDTId
              );
            }}
            className="far fa-trash-alt"
          ></i>
        </div>
      ),
    },
  ];
  const RecHTColumn = [
    {
      Header: "SNo",
      accessor: "sNo",
      maxWidth: 70,
      style: { justifyContent: "center" },
    },

    {
      Header: "Receipt Mode",
      accessor: "paymentMode",
      style: { justifyContent: "center" },
    },
    {
      Header: "Receipt Date",
      accessor: "recDate",
      style: { justifyContent: "center" },
    },
    {
      Header: "Receipt No",
      accessor: "recNo",
      style: { justifyContent: "center" },
    },
    {
      Header: "Receipt Amount",
      accessor: "recAmt",
      Cell: (props) => Number(props.value || 0).toFixed(2),
      style: { justifyContent: "right" },
    },
    {
      Header: "Settled Amount",
      accessor: "adjustAmt",
      Cell: (props) => Math.abs(Number(props.value || 0)).toFixed(2),
      style: { justifyContent: "right" },
    },
    {
      Header: "Balance Amount",
      accessor: "unAdjustAmt",
      Cell: (props) => Number(props.value || 0).toFixed(2),
      style: { justifyContent: "right" },
    },
  ];
  const RecDTColumn = [
    {
      Header: "SNo",
      accessor: "sNo",
      maxWidth: 70,
      style: { justifyContent: "center" },
    },
    {
      Header: "Vouch Type",
      accessor: "vouchType",
      style: { justifyContent: "center" },
    },
    {
      Header: "Bill Type",
      accessor: "billType",
      style: { justifyContent: "center" },
    },
    {
      Header: "Vouch Date",
      accessor: "vouchDate",
      style: { justifyContent: "center" },
    },
    {
      Header: "Vouch No",
      accessor: "vouchNo",
      style: { justifyContent: "left" },
    },
    {
      Header: "Vouch Amount",
      accessor: "vouchAmt",
      Cell: (props) => Number(props.value || 0).toFixed(2),
      style: { justifyContent: "right" },
    },
    {
      Header: "Settled Amount",
      accessor: "adjustAmt",
      Cell: (props) => Math.abs(Number(props.value || 0)).toFixed(2),
      style: { justifyContent: "right" },
    },
    {
      Header: "Balance Amount",
      accessor: "unAdjustAmt",
      Cell: (props) => Number(props.value || 0).toFixed(2),
      style: { justifyContent: "right" },
    },
    {
      Header: "Amount",
      accessor: "amount",
      Cell: (props) => Number(props.value || 0).toFixed(2),
      show: _HTParem.isUnSettle,
      style: { justifyContent: "right" },
    },
    {
      Header: "Options",
      id: "recDTId",
      maxWidth: 70,
      style: { justifyContent: "center" },
      show: !_HTParem.isUnSettle,
      accessor: (rowInfo) => (
        <div>
          <i
            onClick={() => {
              Ask_Question(
                dispatch,
                Delete_Settlement,
                "Do You Want to  Delete Settlement?",
                rowInfo.recDTId
              );
            }}
            className="far fa-trash-alt"
          ></i>
        </div>
      ),
    },
  ];
  return (
    <>
      <div className="row">
        <div className="col-md-3 col-sm-6 mt-1">
          <label>
            Vendor Name <span className="danger">*</span>
          </label>
          <CustomizedSelectoption
            optionparem="isoptionShow"
            showoption={_Selectparem.isoptionShow}
            placeholder="Select Vendore"
            onChange={(val) => {
              View_AllVendores(_HTParem.iVenTypeId, val);
            }}
            select_value={(val) => View_Party(val)}
            btnname="Vendor"
            btnshow={false}
            show_popup=""
            valueonly={true}
            defaultval={_HTParem.iVenId}
            displayName="partyName"
            disvalue="partyId"
            arrydata={arrVendore}
            EmptVal="Vendor "
          />
        </div>
        <div className="col-md-2 col-sm-6">
          <label>Vendor Type</label>
          <CustomizedSelectoption
            optionparem="isoptionShow1"
            showoption={_Selectparem.isoptionShow1}
            placeholder="Select Vendore Type"
            select_value={(val) => Ven_typeonchange(Number(val))}
            btnname="Vendor type"
            btnshow={false}
            show_popup=""
            valueonly={true}
            defaultval={_HTParem.iVenTypeId}
            displayName="strVenTypeName"
            disvalue="iVenTypeId"
            arrydata={_DTParem.arrVenType}
            EmptVal="Vendor Type "
          />
        </div>
        <div className="col-md-2 col-sm-6">
          <label>Voucher Type</label>
          <CustomizedSelectoption
            optionparem="isoptionShow2"
            showoption={_Selectparem.isoptionShow2}
            placeholder="Select Voucher Type"
            select_value={(val) => {
              if (Number(val) === Number(_HTParem.iScrId)) return;
              dispatch(setsettlementvouchtype(Number(val)));
              LoadPayVouchers(_HTParem.iVenId, Number(val));
            }}
            btnname="Voucher Type"
            btnshow={false}
            show_popup=""
            valueonly={true}
            defaultval={_HTParem.iScrId}
            displayName="strScrName"
            disvalue="iScrId"
            arrydata={_DTParem.arrVouchType}
            EmptVal="Voucher Type"
          />
        </div>
        <div className="col-md-2 col-sm-6">
          <label>From Date</label>
          <input
            type="date"
            name="FromDate"
            className="form-control"
            value={_HTParem.strFromDate}
            onChange={(e) => {
              const val = e.target.value;
              dispatch(setsettlementfromdate(val));
              LoadPayVouchers(_HTParem.iVenId, _HTParem.iScrId, {
                dpFrom: val,
              });
            }}
          />
        </div>
        <div className="col-md-2 col-sm-6">
          <label>To Date</label>
          <input
            type="date"
            name="ToDate"
            className="form-control"
            value={_HTParem.strToDate}
            onChange={(e) => {
              const val = e.target.value;
              dispatch(setsettlementtodate(val));
              LoadPayVouchers(_HTParem.iVenId, _HTParem.iScrId, {
                dpTo: val,
              });
            }}
          />
        </div>
      </div>
      <ReactTable
        columns={
          props.PartyUrl === "ReceiptSettlement" ? RecHTColumn : PayHTColumn
        }
        data={arrHTShow}
        minRows={5}
        row_click={(rowInfo, Index) => {
          setiHTselected(Index);
        }}
        row_doubleclick={(rowInfo, Index) => {
          if (!_HTParem.isUnSettle) LoadVouchers(rowInfo);
          else SelectPayment(rowInfo);
        }}
        background={true}
        className="full-table"
      />
      {_HTParem.isUnSettle && (
        <div className="p-2">
          <div className="row">
            <div className="col-sm-6 col-md-2">
              <label>Voucher Number </label>
              <input
                type="text"
                aria-label="First name"
                className="form-control"
                name="VenName"
                id="VenName"
                value={_HTParem.strVouchNo}
                onClick={(e) => e.target.select()}
                readOnly
              />
            </div>
            <div className="col-sm-6 col-md-2">
              <label>UN Settled Amount </label>
              <input
                type="number"
                aria-label="First name"
                className="form-control"
                name="dUnSettleAmount"
                id="dUnSettleAmount"
                value={_HTParem.dUnSettleAmount}
                readOnly
              />
            </div>
            <div className="col-sm-6 col-md-2">
              <label>Amount </label>
              <input
                type="number"
                aria-label="First name"
                className="form-control"
                name="dAmount"
                id="dAmount"
                value={_HTParem.dAmount}
                onChange={(e) =>
                  dispatch(setsettlementdAmount(Number(e.target.value)))
                }
                onClick={(e) => e.target.select()}
              />
            </div>
            <div className="col-sm-6 col-md-2">
              <br />
              <button
                type="button"
                onClick={Adjust_Voucher}
                className="trans-add-btn "
              >
                Adjust
              </button>
            </div>
            <div className="col-sm-12 col-md-3">
              <div className="net-amount">
                <h1>Available Amount</h1>
                <h2>
                  {new Intl.NumberFormat("en-GB", {
                    style: "currency",
                    currency: "INR",
                  }).format(Number(_HTParem.dBalAmount).toFixed(2))}
                </h2>
              </div>
            </div>
          </div>
        </div>
      )}
<ReactTable
  columns={
    props.PartyUrl === "ReceiptSettlement" ? RecDTColumn : PayDTColumn
  }
  data={arrDTShow}
  minRows={5}
  row_click={(rowInfo, Index) => {
    setiDTselected(Index);
  }}
  row_doubleclick={(rowInfo, Index) => {
    setiDTselected(Index);
    dispatch(
      setselectedvoucher({
        iVouchId: rowInfo.vouchId,
        strVouchNo: rowInfo.vouchNo,
        dUnSettleAmount: Number(rowInfo.unAdjustAmt || 0).toFixed(2),
        strVouchType: rowInfo.vouchType,
        dAmount: rowInfo.amount,
      })
    );
  }}
  background={true}
  className="full-table"
/>
    </>
  );
}
export default SettlementInput;